export const NONE_SELECTED = "None Selected";
// Label filter bucket for records with no label assigned ([], missing or "").
// Distinct from NONE_SELECTED (the multilabel [""] sentinel).
export const UNLABELED = "Unlabeled";
// Wire value sent to the backend labels filter for the UNLABELED bucket. Must
// match UNLABELED_FILTER_SENTINEL in optuneutils/dataset/dataset_query.py.
export const UNLABELED_FILTER_SENTINEL = "__UNLABELED__";
export const ALL_LABELS = "ALL_LABELS";

// Status filter options for the table
export const STATUS_FILTERS = {
    SUCCESSFUL: 'success',
    FAILED: 'failed',
    NOT_PROCESSED: 'not_processed'
};

// Table filter options
export const EXAMPLE_STATUS_FILTERS = [
    { text: 'Successful', value: STATUS_FILTERS.SUCCESSFUL },
    { text: 'Failed', value: STATUS_FILTERS.FAILED },
    { text: 'Not Processed', value: STATUS_FILTERS.NOT_PROCESSED }
];

export const RESPONSE_STATUS_FILTERS = [
    { text: 'Successful', value: STATUS_FILTERS.SUCCESSFUL },
    { text: 'Failed', value: STATUS_FILTERS.FAILED },
    { text: 'Not Processed', value: STATUS_FILTERS.NOT_PROCESSED }
];

// Tab keys
export const TAB_KEYS = {
    FORMATTED: 'formatted',
    RAW: 'raw'
}; 